export enum Events {
  REQUEST_MORE_INFO = 'Request More Information'
}
